import React from 'react'
import './PartnershipBanner.css'
import partnershipBg from '../../../../assets/images/partnership/bg.webp'
import partnershipBg2 from '../../../../assets/images/partnership/layer.png'

const PartnershipBanner = () => {
  return (
    <section className="partnership">
      <img src={partnershipBg} alt="" className="partnership-bg" />
      <img src={partnershipBg2} alt="" className="partnership-bg2" />

 

      <div className="partnership-container">
        <div className="partnership-content">
          <h2>
            Strategic Global <br />
            Partnerships
          </h2>

          <p>
            API collaborates with international engineering firms and pharmaceutical
            technology providers to ensure that the facility, production systems, and
            operational standards meet global pharmaceutical industry benchmarks.
          </p>
        </div>
      </div>
    </section>
  )
}

export default PartnershipBanner